import { Component } from '../lib/ComponentBase';
import { simpleComponent } from '../lib/ComponentHelpers';
import type { TagComponent } from '../types/Components';

/**
 * A tag component for entities that are walkable.
 */
class IsWalkable extends Component implements TagComponent {}

export default simpleComponent(IsWalkable);
